import api from 'api';

export const loadUsersSuggestions = api('GET /api/users-suggestions');
